import { render, staticRenderFns } from "./HouseTypeCategories.vue?vue&type=template&id=dc8d2ce2&scoped=true&"
import script from "./HouseTypeCategories.vue?vue&type=script&lang=js&"
export * from "./HouseTypeCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8d2ce2",
  null
  
)

export default component.exports